export default {
  bind(canvas, binding) {
    canvas.width = 200
    canvas.height = 200
    const ctx = canvas.getContext('2d')
    let loadingTxt="LOADING.....";
    if (!binding.value) {
      loadingTxt='No Image';
    }
    let loadingTextWidth = ctx.measureText(loadingTxt).width
    ctx.fillStyle = 'gray'
    ctx.fillRect(0, 0, 200, 200)
    ctx.fillStyle='#ffffff';
    ctx.fillText(loadingTxt,(canvas.width-loadingTextWidth)/2,100)
    const img = new Image()
    img.src = binding.value
    img.onload = () => {
      ctx.clearRect(0,0,canvas.width,canvas.height);
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = currentDate.getMonth() + 1
      const day = currentDate.getDate()
      let watermarkText = ''
      const watermakerInfo = localStorage.getItem('userName')
      if (watermakerInfo) {
        watermarkText = watermakerInfo
      }
      const txt = `${watermarkText} ${year}-${month}-${day}`
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)'
      ctx.font = 'bold 30px Microsoft YaHei'
      ctx.fillStyle = 'rgba(255, 255, 255, 0.15)'
      ctx.textAlign = 'left'
      ctx.textBaseline = 'middle'
      ctx.rotate(-20 * Math.PI / 180)
      let spacing = 100
      let fontSize = 30
      const textWidth = ctx.measureText(txt).width
      // Calculate the area size to cover (considering rotation)
      const diagonal = Math.sqrt(canvas.width * canvas.width + canvas.height * canvas.height)
      const cols = Math.ceil(diagonal / (textWidth + spacing))
      const rows = Math.ceil(diagonal / (fontSize + spacing))

      // Draw grid watermark
      for (let i = -rows; i < rows; i++) {
        for (let j = -cols; j < cols; j++) {
          const x = j * (textWidth + spacing)
          const y = i * (fontSize + spacing)
          ctx.strokeText(txt, x, y)
          ctx.fillText(txt, x, y)
        }
      }

    }
    img.onerror=()=>{
      ctx.clearRect(0,0,canvas.width,canvas.height);
      ctx.fillStyle = 'gray'
      ctx.fillRect(0, 0, 200, 200)
      ctx.fillStyle='red';
      loadingTxt="Image Error";
      loadingTextWidth = ctx.measureText(loadingTxt).width
      ctx.fillText(loadingTxt,(canvas.width-loadingTextWidth)/2,100)
    }
    canvas.onclick = () => {
      // Create adivElement
      const overlay = document.createElement('div')

      // SetdivStyle
      overlay.style.position = 'fixed' // Fixed positioning, relative to viewport
      overlay.style.top = '0'
      overlay.style.left = '0'
      overlay.style.width = '100%'
      overlay.style.height = '100%'
      overlay.style.textAlign = 'center'
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)' // Black semi-transparent background
      overlay.style.zIndex = '99999999' // EnsuredivAt top level
      overlay.style.display = 'flex'
      overlay.style.justifyContent = 'center'
      overlay.style.alignItems = 'center'

      // Create a newcanvasObject
      var previewCanvas = document.createElement('canvas')
      var previewCtx = previewCanvas.getContext('2d')
      previewCanvas.width = canvas.width
      previewCanvas.height = canvas.height
      previewCtx.drawImage(canvas, 0, 0)
      overlay.appendChild(previewCanvas)
      // Add div to body
      document.body.appendChild(overlay)
      // ClickdivDelete self
      overlay.addEventListener('click', function() {
        this.remove()
      })

      // Listen keyboard events
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          overlay.remove()
        }
      })
    }

  }
}